import React, { useEffect, useState } from "react";
import { useAIWorkflowContext } from "../../../../context/ai-workflow.context";
import { NodeType } from "../../../../helper/constant";
import { useReactFlow } from "@xyflow/react";
import { useAIModelContext } from "../../../../context/ai-model.context";
import CustomDropdown from "../../../common/CustomDropdown";
import { Form } from "react-bootstrap";
import { useAuthContext } from "../../../../context/auth.context";

const WorkflowNodeConfig = (props) => {
    const [forms, setForms] = useState({ workflowId: null, approval: true });
    const [flowData, setFlowData] = useState({ id: '', name: '', url: '', input_type: '', input: [] })
    const { setNodes } = useReactFlow();
    const { updateRightMenu } = useAIModelContext();
    const { selectedNode, workflows, workflowEdit, getWorkflowList } = useAIWorkflowContext();
    const { userInfo: { user } } = useAuthContext();

    useEffect(() => {
        if (workflows.length === 0)
            getWorkflowList();
    }, [workflows])

    useEffect(() => {
        if (selectedNode && selectedNode.data) {
            setForms({ workflowId: selectedNode.data.id, approval: selectedNode.data.approval });
        }

    }, [selectedNode]);

    useEffect(() => {
        if (forms.workflowId && workflows && workflows.length) {
            const item = workflows.filter(i => i.id === forms.workflowId)[0];
            const inputNode = item.template.nodes.filter(i => i.type === NodeType.InputNode);
            if (inputNode.length && inputNode[0].data.input_type === 'manual') {
                setFlowData({ id: item.id, name: item.name, url: item.url, input_type: inputNode[0].data.input_type, input: inputNode[0].data.input });
            } else {
                setFlowData({ id: item.id, name: item.name, url: item.url, input_type: inputNode[0].data.input_type, input: [] });
            }
        }
    }, [forms.workflowId, workflows])

    const renderWorkflowList = () => {
        return (
            <div>
                <CustomDropdown
                    name="Existing Workflow"
                    options={workflows}
                    field="name"
                    value={forms.workflowId}
                    onChange={workflowId => setForms({ ...forms, workflowId })}
                />
            </div>
        )
    }


    const renderFieldMissing = () => {
        return (
            <Form.Check
                type="checkbox"
                id='autoApprove'
                label="Approval Required"
                value={forms.approval}
                onChange={() => setForms({ ...forms, approval: !forms.approval })}
            />
        )
    }
    const onFormSubmit = e => {
        e.preventDefault();
        const { id } = selectedNode;
        console.log({ user });

        setNodes((nodes) => nodes.map((node) =>
            node.id === id
                ? {
                    ...node, data: {
                        ...node.data,
                        id: flowData.id,
                        name: flowData.name,
                        url: flowData.url,
                        input_type: flowData.input_type,
                        input: flowData.input,
                        approval: forms.approval,
                        email: user.email
                    }
                }
                : node
        ));
        updateRightMenu(false);
    }

    const renderSaveButton = () => {
        return (
            <div className="form-group">
                <button
                    type="submit"
                    className="btn2 btn radious-0 w-100 f-13 text-uppercase py-2 font15 fontweight600">
                    save
                </button>
            </div>
        )
    }
    const renderConfigForm = () => {
        return (
            <form className="d-flex flex-column gap-2" onSubmit={onFormSubmit} noValidate>
                {renderWorkflowList()}
                {renderFieldMissing()}
                {renderSaveButton()}
            </form>
        )
    }

    const renderConfigrationStatus = () => {
        return (
            <div className="d-flex flex-column flex-wrap gap-1">
                <p className="p-0 m-0">
                    <span className="text-black">Workflow name :</span>
                    <span className="text-secondary capitalize"> {selectedNode.data.name}</span>
                </p>
                <p className="p-0 m-0">
                    <span className="text-black">Approval Required :</span>
                    <span className="text-secondary capitalize"> {selectedNode.data.approval ? 'Yes' : 'No'}</span>
                </p>
            </div>
        )
    }

    const render = () => {
        return (
            <div className="d-flex flex-column flex-wrap gap-3 pt-3">
                <h5>Workflow Node Configuration</h5>
                {workflowEdit ? renderConfigForm() : renderConfigrationStatus()}
            </div>
        )
    }
    return render();

}

export default WorkflowNodeConfig